import Image from 'next/image'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import CardPeriod from 'app/KinerjaShared/components/CardPeriod'

import type { Kinerja } from 'types/kinerja'

interface CardPelaksanaanCompletedProps {
  period: Kinerja['period']
  year: Kinerja['tahun']
}

export default function CardPelaksanaanCompleted({
  period = 1,
  year,
}: CardPelaksanaanCompletedProps) {
  return (
    <Card className="p-6">
      <div className="flex gap-6">
        <div className="flex-shrink-0">
          <Image
            alt=""
            src="/illustrations/img-success-document-publish.png"
            width={84}
            height={84}
          />
        </div>
        <div className="flex-1 flex flex-col gap-1 justify-center">
          <Text
            variant="subheading"
            color="informational"
            className="!text-blue-60 !uppercase tracking-[0.5px]"
          >
            <CardPeriod
              period={period}
              withDate
              year={year}
              withYear={false}
              enableMultiplePeriodSupport
            />
          </Text>
          <div className="flex items-center gap-2">
            <Text variant="heading-lg">
              Seluruh tahap sudah berhasil dilakukan!
            </Text>
          </div>
          <Text color="subdued" className="max-w-3xl">
            Terima kasih sudah menyelesaikan seluruh tahap, ya. Proses akan
            dilanjutkan oleh atasan. Silakan cek tahap-tahapnya atau diskusikan
            dengan atasan untuk selengkapnya.
          </Text>
        </div>
      </div>
    </Card>
  )
}
